import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownBold = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M28.7075 9.2932C28.52 9.1057 28.2656 9.00037 28.0004 9.00037C27.7353 9.00037 27.4809 9.1057 27.2934 9.2932L16 20.5862L4.70699 9.2932C4.51851 9.11038 4.26568 9.00903 4.0031 9.01104C3.74053 9.01304 3.48928 9.11824 3.30361 9.30392C3.11794 9.4896 3.01276 9.74086 3.01077 10.0034C3.00878 10.266 3.11015 10.5188 3.29299 10.7073L15.293 22.7073C15.4805 22.8948 15.7348 23.0001 16 23.0001C16.2652 23.0001 16.5195 22.8948 16.707 22.7073L28.707 10.7073C28.8946 10.5198 29 10.2655 29.0001 10.0004C29.0002 9.73517 28.8949 9.4808 28.7075 9.2932Z",
		fill: "currentColor"
	})
});
export default SvgArrowDownBold;
